module.exports = "/images/fachada.jpeg?e04a479796853a472fe0a4575b622bd1";